/* tslint:disable */
/* eslint-disable */
/**
 * HR Recruiter API — Company Credits
 * OpenAPI спецификация для управления кредитами компаний в SaaS-архитектуре. Система контроля потребления ресурсов через кредиты. 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@hr-recruiter.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Запрос на добавление/списание кредитов
 * @export
 * @interface AddCreditsRequest
 */
export interface AddCreditsRequest {
    /**
     * 
     * @type {CreditType}
     * @memberof AddCreditsRequest
     */
    'creditType': CreditType;
    /**
     * Количество кредитов для добавления/списания. Положительные значения добавляют кредиты, отрицательные - списывают. 
     * @type {number}
     * @memberof AddCreditsRequest
     */
    'amount': number;
}


/**
 * Информация о кредитах определенного типа
 * @export
 * @interface CompanyCreditsDto
 */
export interface CompanyCreditsDto {
    /**
     * 
     * @type {CreditType}
     * @memberof CompanyCreditsDto
     */
    'creditType': CreditType;
    /**
     * Общее количество выделенных кредитов
     * @type {number}
     * @memberof CompanyCreditsDto
     */
    'totalAllocated': number;
    /**
     * Количество использованных кредитов
     * @type {number}
     * @memberof CompanyCreditsDto
     */
    'usedCount': number;
    /**
     * Количество доступных кредитов (totalAllocated - usedCount)
     * @type {number}
     * @memberof CompanyCreditsDto
     */
    'available': number;
}


/**
 * Ответ с информацией о кредитах компании
 * @export
 * @interface CompanyCreditsResponse
 */
export interface CompanyCreditsResponse {
    /**
     * ID компании
     * @type {number}
     * @memberof CompanyCreditsResponse
     */
    'companyId': number;
    /**
     * Список кредитов по типам
     * @type {Array<CompanyCreditsDto>}
     * @memberof CompanyCreditsResponse
     */
    'credits': Array<CompanyCreditsDto>;
}
/**
 * Типы кредитов для контроля потребления ресурсов: - **INTERVIEW_CREDITS** - кредиты на создание собеседований - **POSITION_CREDITS** - кредиты на создание вакансий - **SEARCH_CREDITS** - кредиты на поиск (пока только отображаем, не тратим) - **ACCOUNT_CREDITS** - кредиты на создание аккаунтов - **DIALOG_CREDITS** - кредиты на все диалоги (общий лимит) - **DIALOG_CREDITS_WHATSAPP** - кредиты на диалоги WhatsApp (подлимит) 
 * @export
 * @enum {string}
 */

export const CreditType = {
    INTERVIEW_CREDITS: 'INTERVIEW_CREDITS',
    POSITION_CREDITS: 'POSITION_CREDITS',
    SEARCH_CREDITS: 'SEARCH_CREDITS',
    ACCOUNT_CREDITS: 'ACCOUNT_CREDITS',
    DIALOG_CREDITS: 'DIALOG_CREDITS',
    DIALOG_CREDITS_WHATSAPP: 'DIALOG_CREDITS_WHATSAPP'
} as const;

export type CreditType = typeof CreditType[keyof typeof CreditType];


/**
 * Стандартный ответ об ошибке
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * Сообщение об ошибке
     * @type {string}
     * @memberof ErrorResponse
     */
    'message': string;
    /**
     * Список ошибок валидации
     * @type {Array<string>}
     * @memberof ErrorResponse
     */
    'errors'?: Array<string>;
}

/**
 * CompanyCreditsApi - axios parameter creator
 * @export
 */
export const CompanyCreditsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Добавить или списать кредиты определенного типа для компании. Доступно только для SUPER_ADMIN.  **Особенности:** - Положительные значения добавляют кредиты к существующим - Отрицательные значения списывают кредиты (уменьшают общее количество) - Если записи кредитов не существует, она создается автоматически - Все операции логируются в аудит 
         * @summary Добавить/списать кредиты компании
         * @param {number} companyId ID компании
         * @param {AddCreditsRequest} addCreditsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompanyCredits: async (companyId: number, addCreditsRequest: AddCreditsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('addCompanyCredits', 'companyId', companyId)
            // verify required parameter 'addCreditsRequest' is not null or undefined
            assertParamExists('addCompanyCredits', 'addCreditsRequest', addCreditsRequest)
            const localVarPath = `/admin/companies/{companyId}/credits`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication SuperAdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCreditsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Получить информацию о всех типах кредитов для указанной компании. Доступно только для SUPER_ADMIN.  **Возвращает:** - Общее количество выделенных кредитов по каждому типу - Количество использованных кредитов - Количество доступных кредитов 
         * @summary Получить кредиты компании
         * @param {number} companyId ID компании
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyCredits: async (companyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getCompanyCredits', 'companyId', companyId)
            const localVarPath = `/admin/companies/{companyId}/credits`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication SuperAdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyCreditsApi - functional programming interface
 * @export
 */
export const CompanyCreditsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyCreditsApiAxiosParamCreator(configuration)
    return {
        /**
         * Добавить или списать кредиты определенного типа для компании. Доступно только для SUPER_ADMIN.  **Особенности:** - Положительные значения добавляют кредиты к существующим - Отрицательные значения списывают кредиты (уменьшают общее количество) - Если записи кредитов не существует, она создается автоматически - Все операции логируются в аудит 
         * @summary Добавить/списать кредиты компании
         * @param {number} companyId ID компании
         * @param {AddCreditsRequest} addCreditsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCompanyCredits(companyId: number, addCreditsRequest: AddCreditsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCompanyCredits(companyId, addCreditsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyCreditsApi.addCompanyCredits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Получить информацию о всех типах кредитов для указанной компании. Доступно только для SUPER_ADMIN.  **Возвращает:** - Общее количество выделенных кредитов по каждому типу - Количество использованных кредитов - Количество доступных кредитов 
         * @summary Получить кредиты компании
         * @param {number} companyId ID компании
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyCredits(companyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyCreditsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyCredits(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyCreditsApi.getCompanyCredits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CompanyCreditsApi - factory interface
 * @export
 */
export const CompanyCreditsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyCreditsApiFp(configuration)
    return {
        /**
         * Добавить или списать кредиты определенного типа для компании. Доступно только для SUPER_ADMIN.  **Особенности:** - Положительные значения добавляют кредиты к существующим - Отрицательные значения списывают кредиты (уменьшают общее количество) - Если записи кредитов не существует, она создается автоматически - Все операции логируются в аудит 
         * @summary Добавить/списать кредиты компании
         * @param {number} companyId ID компании
         * @param {AddCreditsRequest} addCreditsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompanyCredits(companyId: number, addCreditsRequest: AddCreditsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addCompanyCredits(companyId, addCreditsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Получить информацию о всех типах кредитов для указанной компании. Доступно только для SUPER_ADMIN.  **Возвращает:** - Общее количество выделенных кредитов по каждому типу - Количество использованных кредитов - Количество доступных кредитов 
         * @summary Получить кредиты компании
         * @param {number} companyId ID компании
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyCredits(companyId: number, options?: RawAxiosRequestConfig): AxiosPromise<CompanyCreditsResponse> {
            return localVarFp.getCompanyCredits(companyId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompanyCreditsApi - object-oriented interface
 * @export
 * @class CompanyCreditsApi
 * @extends {BaseAPI}
 */
export class CompanyCreditsApi extends BaseAPI {
    /**
     * Добавить или списать кредиты определенного типа для компании. Доступно только для SUPER_ADMIN.  **Особенности:** - Положительные значения добавляют кредиты к существующим - Отрицательные значения списывают кредиты (уменьшают общее количество) - Если записи кредитов не существует, она создается автоматически - Все операции логируются в аудит 
     * @summary Добавить/списать кредиты компании
     * @param {number} companyId ID компании
     * @param {AddCreditsRequest} addCreditsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyCreditsApi
     */
    public addCompanyCredits(companyId: number, addCreditsRequest: AddCreditsRequest, options?: RawAxiosRequestConfig) {
        return CompanyCreditsApiFp(this.configuration).addCompanyCredits(companyId, addCreditsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Получить информацию о всех типах кредитов для указанной компании. Доступно только для SUPER_ADMIN.  **Возвращает:** - Общее количество выделенных кредитов по каждому типу - Количество использованных кредитов - Количество доступных кредитов 
     * @summary Получить кредиты компании
     * @param {number} companyId ID компании
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyCreditsApi
     */
    public getCompanyCredits(companyId: number, options?: RawAxiosRequestConfig) {
        return CompanyCreditsApiFp(this.configuration).getCompanyCredits(companyId, options).then((request) => request(this.axios, this.basePath));
    }
}



